'use strict';

import Vue from 'vue';
import App from './App.vue';
import VueRouter from 'vue-router';
import router from './routes';
import firebase from 'firebase/app';
import VueScrollTo from 'vue-scrollto';
import 'firebase/auth';
import { ClientTable } from 'vue-tables-2';
import JsonCSV from 'vue-json-csv'
import JsonExcel from "vue-json-excel";
import VModal from 'vue-js-modal';

// Configurations
import firebaseConfig from './config/firebase';
// Global components
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Loading from './components/Loading';
import Alert from './components/Alert';
import NewArtistModal from "@/components/NewArtistModal";

Vue.use(VueRouter);
Vue.use(ClientTable);
Vue.use(VueScrollTo);
Vue.use(VModal, { dialog: true });

Vue.component('Header', Header);
Vue.component('Sidebar', Sidebar);
Vue.component('Footer', Footer);
Vue.component('Loading', Loading);
Vue.component('Alert', Alert);
Vue.component('downloadCsv', JsonCSV)
Vue.component("downloadExcel", JsonExcel);
Vue.component("NewArtistModal", NewArtistModal);

Vue.config.productionTip = false;
firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
